import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '../CircularProgress';
import { StyledEmbed, StyledEmbedFrame, StyledBox } from './Styles';
function Embed(_ref) {
  var height = _ref.height,
    src = _ref.src,
    width = _ref.width;
  return /*#__PURE__*/React.createElement(StyledEmbed, {
    height: height,
    width: width
  }, /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 50
  })), /*#__PURE__*/React.createElement(StyledEmbedFrame, {
    src: src,
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: true
  }));
}
Embed.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Defines the height of embed container
   */
  height: PropTypes.string,
  /**
   * Url to embed in frame
   */
  src: PropTypes.string.isRequired,
  /**
   * Defines the width of embed container
   */
  width: PropTypes.string
} : {};
Embed.defaultProps = {
  height: '50%',
  width: '100%'
};
export default Embed;